import { InjectionToken } from '@angular/core';
import { IEnvironment } from '../models';

export const ENVIRONMENTS = new InjectionToken<IEnvironment>('Environments');
